var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpaceTreeIcon = function SvgSpaceTreeIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 132.292 132.292",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", {
    strokeOpacity: 1,
    transform: "matrix(1.03848 0 0 1.03848 -2.545 -1.387)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillOpacity: 1,
    stroke: "#d4d4d4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeWidth: 0.794,
    d: "M66.146 16.013v9.755",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d4d4d4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeWidth: 0.794,
    d: "M56.507 48.003C42.725 61.691 23.99 61.48 18.503 74.266",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d4d4d4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeWidth: 0.794,
    d: "M60.737 51.048c-3.518 7.613-9.532 12.475-10.49 23.12",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d4d4d4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeWidth: 0.794,
    d: "M71.77 50.781C75.288 58.394 81.3 63.255 82.26 73.9",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d4d4d4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeWidth: 0.794,
    d: "M75.568 48.003c13.783 13.688 32.517 13.477 38.004 26.263",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d4d4d4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeWidth: 0.794,
    d: "M49.303 87.429c-2.512 9.288-13.719 12.76-14.931 26.45",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d4d4d4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeWidth: 0.794,
    d: "M51.293 87.429c2.512 9.288 13.719 12.76 14.931 26.45",
    display: "inline"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.146,
    cy: 9.525,
    r: 6.615,
    fill: "#dcdcdc",
    fillOpacity: 1,
    stroke: "#565656",
    strokeDasharray: "none",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeWidth: 0.794,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.146,
    cy: 38.968,
    r: 13.229,
    fill: "#dcdcdc",
    fillOpacity: 1,
    stroke: "#565656",
    strokeDasharray: "none",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeWidth: 0.794,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.502,
    cy: 80.849,
    r: 6.615,
    fill: "#dcdcdc",
    fillOpacity: 1,
    stroke: "#565656",
    strokeDasharray: "none",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeWidth: 0.794
  }), /*#__PURE__*/React.createElement("circle", {
    id: "use945",
    cx: 50.365,
    cy: 80.849,
    r: 6.615,
    fill: "#dcdcdc",
    fillOpacity: 1,
    stroke: "#565656",
    strokeDasharray: "none",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeWidth: 0.794
  }), /*#__PURE__*/React.createElement("circle", {
    id: "use947",
    cx: 82.267,
    cy: 80.849,
    r: 6.615,
    fill: "#dcdcdc",
    fillOpacity: 1,
    stroke: "#565656",
    strokeDasharray: "none",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeWidth: 0.794
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.79,
    cy: 80.849,
    r: 6.615,
    fill: "#dcdcdc",
    fillOpacity: 1,
    stroke: "#565656",
    strokeDasharray: "none",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeWidth: 0.794
  }), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "#dcdcdc",
    fillOpacity: 1,
    stroke: "#565656",
    transform: "translate(-15.95 39.687)",
    xlinkHref: "#use945"
  }), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "#dcdcdc",
    fillOpacity: 1,
    stroke: "#565656",
    transform: "translate(-15.95 39.687)",
    xlinkHref: "#use947"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpaceTreeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/space-tree-icon.8f877af64d55345f3aa855cc081801e7.svg";